function fromModifierKey(event: KeyboardEvent): boolean {
	return event.metaKey || event.ctrlKey || event.altKey || event.shiftKey;
}

export { fromModifierKey };
